export const accountList = [
  "Account 1",
  "Account 2",
  "Account 3",
  "Account 4",
  "Account 5",
  "Account 6",
  "Account 7",
  "Account 8",
  "Account 9",
  "Account 10",
];

export const donations = [
  {
    organization: "Organization 1",
    account_number: "account number 1",
  },
  {
    organization: "Organization 2",
    account_number: "account number 2",
  },
  {
    organization: "Organization 3",
    account_number: "account number 3",
  },
  {
    organization: "Organization 4",
    account_number: "account number 4",
  },
];

export const EnglishFormOptions = [
  {
    label: "Debit Account",
    placeholder: "Select Account",
    type: "db",
    error: "Please enter an account",
  },
  {
    label: "Organization",
    placeholder: "Select Organization",
    type: "org",
    error: "Please enter organization",
  },
  {
    label: "Amount",
    placeholder: "Enter Amount",
    type: "am",
    error: "Please enter an amount",
  },
];

export const AmharicFormOptions = [
  {
    label: "የተቀናሽ ሂሳብ ቁጥር",
    placeholder: "የተቀናሽ ሂሳብ ቁጥር ይምረጡ",
    type: "db",
    error: "እባክዎ የተቀናሽ ሂሳብ ቁጥር ይምረጡ",
  },
  {
    label: "ተቋም ይምረጡ",
    placeholder: "ተቋም ይምረጡ",
    type: "org",
    error: "እባከዎ የተቋሙን ስም ይምረጡ ",
  },
  {
    label: "የገንዘብ መጠኑን ያስገቡ",
    placeholder: "የገንዘብ መጠኑን ያስገቡ",
    type: "am",
    error: "እባክዎ የገንዘብ መጠኑን ያስገቡ",
  },
];

export const OromicFormOptions = [
  {
    label: "Lakk. Herregaa hir'atuu",
    placeholder: "Lakk. Herregaa hir'atuu",
    type: "db",
    error: "Maaloo, Lakk. Herregaa hir'atuu galchaa",
  },
  {
    label: "Dhaabbata Filadhaa",
    placeholder: "Dhaabbata Filadhaa",
    type: "org",
    error: "Maaloo, Maqaa Dhaabbataa galchaa",
  },
  {
    label: "Hamma Maallaqaa galchaa",
    placeholder: "Hamma Maallaqaa galchaa",
    type: "am",
    error: "Maaloo, Hamma maallaqa galchaa",
  },
];

export const TgrignaFormOptions = [
  {
    label: "ገንዘብ ዝቅነሰሉ ቑፅሪ ሂሳብ",
    placeholder: "ገንዘብ ዝቅነሰሉ ቑፅሪ ሂሳብ",
    type: "db",
    error: "ገንዘብ ዝቅነሰሉ ቑፅሪ ሂሳብ",
  },
  {
    label: "ትካል ይምረፁ",
    placeholder: "ትካል ይምረፁ",
    type: "org",
    error: "በይዘኦም ናይቲ ትካል ሽም የእትዉ  ",
  },
  {
    label: "መጠን ገንዘብ የእትዉ",
    placeholder: "መጠን ገንዘብ የእትዉ",
    type: "am",
    error: "መጠን ገንዘብ የእትዉ",
  },
];

export const SomaliFormOptions = [
  {
    label: "Xisaabta Debit",
    placeholder: "Xisaabta Debit",
    type: "db",
    error: "Fadlan, geli Xisaabta Debit",
  },
  {
    label: "Dooro shirkeda",
    placeholder: "Dooro shirkeda",
    type: "org",
    error: "Fadlan geli magaca shirkeda",
  },
  {
    label: "Geli cadadka",
    placeholder: "Geli cadadka",
    type: "am",
    error: "Fadlan geli cadadka",
  },
];

export const AfarFormOptions = [
  {
    label: "debit abnah yan mucassaba ixxima",
    placeholder: "debit abnah yan mucassaba ixxima",
    type: "db",
    error: "debit abnah yan mucassaba ixxima",
  },
  {
    label: "Fanteena/Xiso Door",
    placeholder: "Fanteena/Xiso Door",
    type: "org",
    error: "Qafu Abaay Fanteenak Migaq Culus",
  },
  {
    label: "Lakqo Qadad Culus",
    placeholder: "Lakqo Qadad Culus",
    type: "am",
    error: "Lakqo Qadad Culus",
  },
];

export const language = [
  {
    options: EnglishFormOptions,
    button: "Transfer Money",
    name: "EN",
    title: "Donation",
  },
  {
    options: AmharicFormOptions,
    button: "ገንዘቡ ይተላለፍ",
    name: "አማርኛ",
    title: "የገንዘብ ድጋፍ",
  },
  {
    options: OromicFormOptions,
    button: "Maallaqa Dabarsi",
    name: "OR",
    title: "Deeggarsa Maallaqaa",
  },
  {
    options: TgrignaFormOptions,
    button: "ገንዘብ ምትሕልላፍ",
    name: "TG",
    title: "ናይ ገንዘብ ሓገዝ",
  },
  {
    options: SomaliFormOptions,
    button: "Lacagta Wareejiso",
    name: "SM",
    title: "Taageerada dhaqaale",
  },
  {
    options: AfarFormOptions,
    button: "Lakqo tabatabsia",
    name: "AF",
    title: "Maaliyyah Qokol",
  },
];

// array of language transaltions specifically for TransferList component.
// imported and used inside TransferList Component

export const transferListLanguageOptions = [
  // ENGLISH
  [
    "SADAQA",
    "Utilities",
    "Standing Payment",
    "School Payment",
    "Other Bank Transfer IPS",
    "Fuel Payment",
    "Mpesa",
    "Hijra Events",
    "Be a Bank Owner",
    "Rent Payment",
      "Hajj Payment",
      "USSD",
      "EMYC Payment",
      "Derash Payment"
  ],

  // AMHARIC
  [
    "ሰደቃ",
    "ክፍያዎች",
    "ቋሚ ክፍያ",
    "የትምህርት ክፍያ",
    "የIPS ክፍያ",
    "የነዳጅ ክፍያ",
    "የMpesa ክፍያ",
    "Hijra Events",
    "የባንክ ባለቤት ይሁኑ",
      "የኪራይ ክፍያ",
      "የሐጅ ክፍያ",
      "USSD",
      "የEMYC ክፍያ",
      "የDerash ክፍያ"
  ],

  // OROMO
  [
    "Sadaqaa",
    "Kafaltii  adda addaa",
    "Kaffaltii Dhaabbataa",
    "Kaffaltii mana barumsaa",
    "Kaffaltii IPS",
    "Kaffaltii boba’aa",
    "Kaffaltii Mpesa",
    "Hijra Events",
    "Baqaata Baankii Ta'i",
      "Rent Payment",
      "Hajj Payment",
      "USSD",
      "Kaffaltii EMYC",
      "Kaffaltii Derash"
  ],

  // TIGRE
  [
    "ሰደቃ",
    "ክፍሊታት",
    "ደው ዝበለ ክፍሊት",
    "ክፍሊት ቤት ትምህርቲ",
    "ክፍሊት IPS",
    "ክፍሊት ነዳጅ",
    "ክፍሊት Mpesa",
    "Hijra Events",
    "ወነክቲ ባንክ ኹኑ",
      "Rent Payment",
      "Hajj Payment",
      "USSD",
      "ክፍሊት EMYC",
      "ክፍሊት Derash"
  ],

  // SOMALE
  [
    "Sadaqo",
    "Lacag bixinta",
    "Lacag bixinta Joogtada ah",
    "Bixinta dugsiyeed",
    "Bixinta IPS",
    "Bixinta shidaal",
    "Bixinta Mpesa",
    "Hijra Events",
    "Noqo Milkiilaha Baanka",
      "Rent Payment",
      "Hajj Payment",
      "USSD",
      "Bixinta EMYC",
      "Bixinta Derash"
  ],

  // AFAR
  [
    "Maaliyyah Qokol",
    "Mekla",
    "Soolisse mekla",
    "Qafala madqisá",
    "Qafala IPS",
    "Qafala nafka",
    "Qafala Mpesa",
    "Hijra Events",
    "Banki Qadaara Yaken",
      "Rent Payment",
      "Hajj Payment",
      "USSD",
      "EMYC Mekla",
      "Derash Mekla"
  ],
];

export const scheduleListLanguageOptions = [
  // ENGLISH
  "Schedule Payment",

  // AMHARIC
  "ሰደቃ",

  // OROMO
  "Sadaqaa",

  // TIGRE
  "ሰደቃ",

  // SOMALE
  "Sadaqo",

  // AFAR
  "Maaliyyah Qokol",
];
export const utilityListLanguageOptions = [
  // ENGLISH
  ["Ethiopian Airlines", "IPS Payment", "Flyzagol Payment"],

  // AMHARIC
  ["የኢትዮጵያ አየር መንገድ", "የIPS ክፍያ", "የFlyzagol ክፍያ"],

  // OROMO
  ["Daandii Qilleensaa Itoophiyaa", "Kaffaltii IPS", "Kaffaltii Flyzagol"],

  // TIGRE
  ["መንገዲ ኣየር ኢትዮጵያ", "ክፍሊት IPS", "ክፍሊት Flyzagol"],

  // SOMALE
  ["Ethiopian Airlines", "Bixinta IPS", "Bixinta Flyzagol"],

  // AFAR
  ["Ethiopian Airlines", "Qafala IPS", "Flyzagol Mekla"],
];

export const shareListLanguageOption = [
    ["Complete share purchase","New Share Purchase"],
  ["Complete share purchase","New Share Purchase"],
  ["Complete share purchase","New Share Purchase"],
  ["Complete share purchase","New Share Purchase"],
  ["Complete share purchase","New Share Purchase"],
  ["Complete share purchase","New Share Purchase"]
]

export const Other = [
  // ENGLISH
  ["Others"],

  // AMHARIC
  ["ሌሎች"],

  // OROMO
  ["Kaan"],

  // TIGRE
  ["ካልኦት"],

  // SOMALE
  ["Kuwa Kole"],

  // AFAR
  ["Gersim"],
];

// AitlineTicket language options
export const airLineTicketLanguageOptions = [
  // ENGLISH
  {
    labels: ["Select account", "Enter your PNR", "Payment reason"],
    placeholder: ["Select Account"],
    valueError: [
      "Please Select account",
      "Please Enter your PNR",
      "Please Enter a reason",
    ],
  },

  // AMHARIC
  {
    labels: ["የተቀናሽ ሂሳብ ቁጥር", "እባክዎ PNR ያስገቡ", "የክፍያ ምክንያት"],
    placeholder: ["የተቀናሽ ሂሳብ ቁጥር ይምረጡ"],
    valueError: [
      "Please Select account",
      "Please Enter your PNR",
      "Please Enter a reason",
    ],
  },

  // OROMO
  {
    labels: ["Lakk. Herregaa hir'atuu", "PNR galchaa", "Sababaa Kafaltii"],
    placeholder: ["Lakk. Herregaa hir'atuu"],
    valueError: [
      "Please Select account",
      "Please Enter your PNR",
      "Please Enter a reason",
    ],
  },

  // TIGRE
  {
    labels: ["ገንዘብ ዝቅነሰሉ ቑፅሪ ሂሳብ", "ኣብ PNR  ኣቲኻ", "ምኸንያት ናይ ክፍያ"],
    placeholder: ["ገንዘብ ዝቅነሰሉ ቑፅሪ ሂሳብ"],
    valueError: [
      "Please Select account",
      "Please Enter your PNR",
      "Please Enter a reason",
    ],
  },

  // SOMALE
  {
    labels: ["Xisaabta Debit", "Geli PNR", "Sababta Lacag Bixinta"],
    placeholder: ["Xisaabta Debit"],
    valueError: [
      "Please Select account",
      "Please Enter your PNR",
      "Please Enter a reason",
    ],
  },
  // AFAR
  {
    labels: [
      "debit abnah yan mucassaba ixxima",
      "Enter your PNR",
      "Meklo sababa",
    ],
    placeholder: ["debit abnah yan mucassaba ixxima"],
    valueError: [
      "Please Select account",
      "Please Enter your PNR",
      "Please Enter a reason",
    ],
  },
];

export const rentLanguageOptions = [
  // ENGLISH
  {
    labels: [
      "Select Account Number",
      "Tenant ID",
      "Search",
      "Pay Now",
        "Payments",
        "Amount Due",
        "Due Date",
        "Tenant",
        "Calculation",
        "Reason"
    ],
    placeholder: ["Select Account"],
    valueError: [
      "Please Select account",
      "Please Enter your PNR",
      "Please Enter Student ID",
      "Please Select School",
    ],
  },

  // AMHARIC
  {
    labels: ["የሂሳብ ቁጥር ምረጥ", "የተከራይ መታወቂያ", "ፈልግ", "አሁን ክፈል","ክፍያዎች","የሚከፈል መጠን", "የመጨረሻ ቀን", "ተከራይ", "ሂሳብ", "ምክንያት"],
    placeholder: ["የሂሳብ ቁጥር ምረጥ"],
    valueError: [
      "Please Select account",
      "Please Enter your PNR",
      "Please Enter a reason",
    ],
  },

  // OROMO
  {
    labels: ["Lakkoofsa Herregaa Filadhu", "ID Qabaatii", "Barbaadi", "Amma Kaffal", "Kaffaltiiwwan","Maallaqa Kaffalamu", "Guyyaa Xumuraa", "Qabaatii", "Hiriyoo", "Sababaa"],
    placeholder: ["Lakk. Herregaa hir'atuu"],
    valueError: [
      "Please Select account",
      "Please Enter your PNR",
      "Please Enter a reason",
    ],
  },

  // TIGRE
  {
    labels: ["ቁጽሪ ሕሳብ ምረጽ", "ኣይዲ ኣካራይ", "ደሊድ", "ሕጂ ክፈል", "ክፍሊታት","ገንዘብ ክፍሊት", "ናይ መወዳእታ ዕለት", "ኣካራይ", "መጽናዕቲ", "ምኽንያት"],
    placeholder: ["ገንዘብ ዝቅነሰሉ ቑፅሪ ሂሳብ"],
    valueError: [
      "Please Select account",
      "Please Enter your PNR",
      "Please Enter a reason",
    ],
  },

  // SOMALE
  {
    labels: ["Xisaab Nambarka Dooro", "Aqoonsiga Kirayaasha", "Raadi", "Bishaar Hadda", "Lacag bixinta","Qadarka Bixiya", "Taariikhda Ugu Dambaysa", "Kirayaasha", "Xisaabinta", "Sababta"],
    placeholder: ["Xisaabta Debit"],
    valueError: [
      "Please Select account",
      "Please Enter your PNR",
      "Please Enter a reason",
    ],
  },
  // AFAR
  {
    labels: ["Account Nummira Fooca", "Qayxi Le", "Gabaaba", "Maaca", "Maaculu", "Maaca Yami", "Maac Xaaca", "Qayxi", "Muxxisa", "Sabab"],
    placeholder: ["debit abnah yan mucassaba ixxima"],
    valueError: [
      "Please Select account",
      "Please Enter your PNR",
      "Please Enter a reason",
    ],
  },
];
export const schoolLanguageOptions = [
  // ENGLISH
  {
    labels: [
      "Select Account Number",
      "Select School",
      "Search Method",
      "By PNR",
      "By Student ID",
      "Enter PNR",
      "Student ID",
      "Search",
      "Loading",
      "School Name",
      "Student Name",
      "Reason",
      "Amount",
      "Processing",
      "Pay Now",
      "Grade",
      "Fee Details",
      "Amount",
      "Final Amount",
      "Previous Amount",
      "Discount",
      "Penalty",
      "Scholarship",
      "Final Amount",
      "Calculate",
      "Continue",
      "By Phone Number",
      "Phone Number",
      "Select Student",
      "Roll Number",
      "Section",
      "Gender",
    ],
    placeholder: ["Select Account"],
    valueError: [
      "Please Select account",
      "Please Enter your PNR",
      "Please Enter Student ID",
      "Please Select School",
    ],
  },

  // AMHARIC
  {
    labels: [
      "የሂሳብ ቁጥር ምረጥ",
      "ትምህርት ቤት ምረጥ",
      "የፈለግ ዘዴ",
      "በ PNR",
      "በተማሪ መለያ",
      "PNR አስገባ",
      "የተማሪ መለያ",
      "ፈልግ",
      "በመጫን ላይ",
      "የትምህርት ቤት ስም",
      "የተማሪ ስም",
      "ምክንያት",
      "መጠን",
      "በሂደት ላይ",
      "አሁን ይክፈሉ",
      "ደረጃ",
      "የክፍያ ዝርዝር",
      "መጠን",
      "የመጨረሻ መጠን",
      "የቀድሞ መጠን",
      "ቅናሽ",
      "ቅጣት",
      "ተምህሮ እርዳታ",
      "የመጨረሻ መጠን",
      "ማስላት",
      "ቀጥል",
      "በስልክ ቁጥር",
      "የስልክ ቁጥር",
      "ተማሪ ይምረጡ",
      "የመዝገብ ቁጥር",
      "ክፍል",
      "ፆታ",
    ],
    placeholder: ["የሂሳብ ቁጥር ምረጥ"],
    valueError: [
      "Please Select account",
      "Please Enter your PNR",
      "Please Enter a reason",
    ],
  },

  // OROMO
  {
    labels: [
      "Lakkoofsa Herregaa Filadhu",
      "Mana Barumsaa Filadhu",
      "Karaa Barbaaduu",
      "PNR tiin",
      "ID Ta’umsaa Barataa tiin",
      "PNR Galchi",
      "ID Barataa",
      "Barbaadi",
      "Kuufamaa jira",
      "Amma Kaffali",
      "Maqaa Mana Barumsaa",
      "Maqaa Barataa",
      "Sababaa",
      "Baay’ina",
      "Hojiirra jira",
      "Sadarkaa",
      "Gatiin Kaffaltii",
      "Baay’ina",
      "Baay’ina Dhumaa",
      "Baay’ina Duraanii",
      "Gatii Gadi buusuu",
      "Adabbii",
      "Qarshii Barannoo",
      "Baay’ina Dhumaa",
      "Himuu",
      "Itti fufi",
      "Lakkoofsa bilbilaatiin",
      "Lakkoofsa bilbilaa",
      "Barataa filadhu",
      "Lakkoofsa galmee",
      "Kutaa",
      "Saala",
    ],
    placeholder: ["Lakk. Herregaa hir'atuu"],
    valueError: [
      "Please Select account",
      "Please Enter your PNR",
      "Please Enter a reason",
    ],
  },

  // TIGRE
  {
    labels: [
      "ቁጽሪ ሕሳብ ምረጽ",
      "ቤት ትምህርቲ ምረጽ",
      "ኣገባብ ድላይ",
      "ብPNR",
      "ብመለለዪ ተማሃራይ",
      "PNR ኣእትው",
      "መለለዪ ተማሃራይ",
      "ድላይ",
      "ተጻዊ",
      "ኣብዚ ሕጂ ክፍሊ",
      "ስም ቤት ትምህርቲ",
      "ስም ተማሃራይ",
      "ምኽንያት",
      "ብዝሒ",
      "ምስራሕ",
      "ደረጃ",
      "ዝርዝር ክፍሊት",
      "ብዝሒ",
      "ናይ መወዳእታ ብዝሒ",
      "ቀዳማይ ብዝሒ",
      "ምቕናስ",
      "ቅጽዓት",
      "ድጋፍ ትምህርቲ",
      "ናይ መወዳእታ ብዝሒ",
      "ግምት ምዃን",
      "ቀፂሉ",
      "ብቑጽሪ ስልኪ",
      "ቑጽሪ ስልኪ",
      "ተማሃራይ ምረጽ",
      "ቑጽሪ መዝገብ",
      "ክፍሊ",
      "ጾታ",
    ],
    placeholder: ["ገንዘብ ዝቅነሰሉ ቑፅሪ ሂሳብ"],
    valueError: [
      "Please Select account",
      "Please Enter your PNR",
      "Please Enter a reason",
    ],
  },

  // SOMALE
  {
    labels: [
      "Xisaab Nambarka Dooro",
      "Dugsiga Dooro",
      "Hab Raadinta",
      "PNR ku",
      "ID Ardayga ku",
      "PNR Geli",
      "ID Ardayga",
      "Raadi",
      "Soo dejinta",
      "Bishaar Hadda",
      "Magaca Dugsiga",
      "Magaca Ardayga",
      "Sababta",
      "Qadarka",
      "Wax-ku-oolka",
      "Heerka",
      "Faahfaahinta Lacagta",
      "Qadarka",
      "Qadarka Dambe",
      "Qadarka Hore",
      "Qiima Dhimis",
      "CiqCiqaab",
      "Deesha Waxbarasho",
      "Qadarka Dambe",
      "Xisaabi",
      "Sii wad",
      "Lambarka Taleefanka",
      "Lambarka Taleefanka",
      "Dooro Ardayga",
      "Lambarka Diiwaanka",
      "Qaybta",
      "Jinsiga",
    ],
    placeholder: ["Xisaabta Debit"],
    valueError: [
      "Please Select account",
      "Please Enter your PNR",
      "Please Enter a reason",
    ],
  },
  // AFAR
  {
    labels: [
      "Hisab Numurta Yokten",
      "Qada Numurta Yokten",
      "Massoyta Qaadâ",
      "PNR Yalli",
      "ID Baratal Yalli",
      "PNR Gexen",
      "ID Baratal",
      "Massoy",
      "Kaxxamal",
      "Qada Maggal",
      "Saaku Qada",
      "Baratal Maggal",
      "Sabab",
      "Qaadâ",
      "Gexxa",
      "Darajâ",
      "Kassat Qaadâ",
      "Qaadâ",
      "Qaadâ Gidir",
      "Qaadâ Qadalti",
      "Qaadâ Dhiif",
      "Adab",
      "Baratal Qaadâ",
      "Qaadâ Gidir",
      "Qiyisa",
      "Gexxi",
      "By Phone Number",
      "Phone Number",
      "Select Student",
      "Roll Number",
      "Section",
      "Gender",
    ],
    placeholder: ["debit abnah yan mucassaba ixxima"],
    valueError: [
      "Please Select account",
      "Please Enter your PNR",
      "Please Enter a reason",
    ],
  },
];

// schedule payment
export const schedulePaymentLanguageOptions = [
  // ENGLISH
  {
    labels: [
      "Select Account",
      "Select Schedule Frequency",
      "Enter Frequency(Days)",
      "Select Start Date",
      "Enter Amount",
      "Enter Reason",
      "Select End Date",
      "Payment Type",
      "Enter To Account",
    ],
    placeholder: [
      "Select Account",
      "To Account",
      "Select Schedule Frequency",
      "Select List",
    ],
    valueError: [
      "Please Select account",
      "Please Select Schedule Frequency",
      "Please Enter frequency",
      "Please Select Start Date",
      "Please Enter amount",
      "Please Enter Reason",
      "Please Select End Date",
      "Please Enter Payment Type",
      "Please Enter To Account",
    ],
    type: ["DAILY", "WEEKLY", "BI_WEEKLY", "MONTHLY", "CUSTOM"],
  },

  // AMHARIC
  {
    labels: [
      "ሂሳብዎን ይምረጡ",
      "የሚደጋገምበትን እቅድ ይምረጡ",
      "የሚደጋገምበትን ቀናት ያስገቡ",
      "የምጀምሩበትን ቀን ይምረጡ",
      "መጠኑን ያስገቡ",
      "ምክንያቱን ያስገቡ",
      "የማብቅያ ቀን ይምረጡ",
      "የክፍያ አይነት",
      "የተቀባይ ሂሳብ ቁጥር ያስገቡ",
    ],
    placeholder: [
      "የተቀናሽ ሂሳብ ቁጥር ይምረጡ",
      "የተቀባይ ሂሳብ ቁጥር",
      "የሚደጋገምበትን እቅድ ይምረጡ",
      "ዝርዝር ይምረጡ",
    ],
    valueError: [
      "እባክዎን ሂሳብዎን ይምረጡ",
      "እባክዎን የምደጋገምበት እቅድዎን ይምረጡ",
      "ድግግሞሹን ያስገቡ",
      "እባክዎን የምጀምሩበትን ቀን ይምረጡ",
      "እባክዎን መጠኑን ያስገቡ",
      "እባክዎን ምክንያቱን ያስገቡ",
      "እባክዎን የማብቅያ ቀን ይምረጡ",
      "እባክዎን የክፍያ አይነት ያስገቡ",
      "እባክዎን የተቀባይ ሂሳብ ቁጥር ያስገቡ",
    ],
    type: ["በየቀኑ", "በየሳምንቱ", "በየሳምንቱ", "በየወሩ", "ብጁ"],
  },

  // OROMO
  {
    labels: [
      "Herrega filadhaa",
      "Sagantaa Irra Deddeebii Filadhaa",
      "Guyyoota Irra Deddeebii Galchaa",
      "Guyyaa Eegalu Filadhaa",
      "Hamma Galchaa",
      "Sababa Galchaa",
      "Guyyaa Xumuraa Filadhaa",
      "Gosa Kaffaltii",
      "Herrega fudhataa galchaa",
    ],
    placeholder: [
      "Herrega Filadhaa",
      "Herrega fudhataa galchaa",
      "Sagantaa Irra Deddeebii Filadhaa",
      "Tarree filadhu",
    ],
    valueError: [
      "Maaloo, Herrega filadhaa",
      "Maaloo, Sagantaa Irra Deddeebii Filadhaa ",
      "Maaloo, Irra Deddeebii Galchaa",
      "Maaloo, Guyyaa Eegalu Filadhaa",
      "Maaloo,Hamma Galchaa",
      "Maaloo, Sababa galchaa",
      "Guyyaa Xumuraa Galchaa",
      "Gosa Kaffaltii",
      "Maaloo, Herrega fudhataa galchaa",
    ],
    type: [
      "GUYYAA GUYYAATTI",
      "TORBEE TORBEE",
      "Torban lama lamatti",
      "JI'A JI'AN",
      "AADAA",
    ],
  },

  // TIGRE
  {
    labels: [
      "ሒሳብ ቑፅሪ ይምረፁ",
      "ድግግም ፕሮግራም ይምረፁ",
      "ዝጅምረሉ ዕለት ይምረፁ",
      "መጠን ገንዘብ የእትዉ",
      "ምኽንያት ይግለፁ",
      "ዝውድአሉ ዕለት ይምረፁ",
      "ክፍሊት ዓይነት የእትዉ",
      "ክፍሊት ዓይነት የእትዉ",
      "ተቐባሊ ኣካውንት ኣእቱ",
    ],
    placeholder: [
      "ገንዘብ ዝቅነሰሉ ቑፅሪ ሂሳብ",
      "ተቐባሊ ኣካውንት ኣእቱ",
      "ድግግም ፕሮግራም ይምረፁ",
      "ዝርዝር ምረጽ",
    ],
    valueError: [
      "በጃኹም ኣካውንት ምረጹ",
      "በጃኹም መደብ ፍሪኩዌንሲ ምረጹ",
      "በጃኹም ፍሪኩዌንሲ ኣእትዉ",
      "በጃኹም ዕለት ምጅማር ምረጹ",
      "በጃኹም መጠን ገንዘብ ኣእትዉ",
      "በጃኹም ምኽንያት ኣእትዉ",
      "በጃኹም መወዳእታ ዕለት ምረጹ",
      "በጃኹም ዓይነት ክፍሊት ኣእትዉ",
      "በጃኹም ተቐባሊ ኣካውንት ኣእቱ",
    ],
    type: ["መዓልታዊ", "ሰሙናዊ", "ኣብ ነፍሲ ወከፍ ክልተ ሰሙን", "ወርሓዊ", "ብዓይነት ዝተዳለወ"],
  },

  // SOMALE
  {
    labels: [
      "Dooro akoonka",
      "Gali inta jeer ee jadwalka",
      "Gali maalmaha jadwalka",
      "Gali taariikhda bilowga",
      "Gali cadadka lacagta",
      "Gali sababta",
      "Gali taariikhda dhamaadk",
      "Nooca lacag bixinta",
      "Geli akoontada qaataha",
    ],
    placeholder: [
      "Dooro akoonka",
      "Geli akoontada qaataha",
      "Gali inta jeer ee jadwalka",
      "Dooro Liiska",
    ],
    valueError: [
      "Fadlan dooro akoonka",
      "fadlan dooro inta jeer ee jadwalka",
      "fadlan dooro maalmaha jadwalka",
      "fadlan dooro taariikhda bilowga",
      "Fadlan dooro cadadka lacagta",
      "fadlan dooro sababta",
      "Fadlan dooro taariikhda dhamaadk",
      "fadlan dooro nooca lacag bixinta",
      "fadlan dooro geli akoontada qaataha",
    ],
    type: [
      "MAALIN WALBA",
      "TODDOBAADKII",
      "Labadii toddobaadba mar",
      "BISHII",
      "LA HABSANAY",
    ],
  },
  // AFAR
  {
    labels: [
      "Akkaawonti door",
      "Uddur Qagaaqagu door",
      "Qagaaqagu culus (ayroora)",
      "Qimmisiyyi ayro door",
      "Caddo culus",
      "Sabab culus",
      "Gabakkaltih ayro door",
      "Meklah Qaynat",
      "culus harge numih akkaawonti",
    ],
    placeholder: [
      "akkaawonti door",
      "culus harge numih akkaawonti",
      "Uddur Qagaaqagu door",
      "Rorta meexa",
    ],
    valueError: [
      "Yallih maganah akkaawonti door",
      "Yallih maganak taddeera qagaaqagitak aysalu door",
      "Yallih maganak qagaaqagu culus",
      "Yallih maganak edde qimbisiyya ayro door",
      "Yallih maganak caddo culus.",
      "Yallih maganak sabab culus",
      "Yallih maganak illacaboh ayro door.",
      "Yallih maganak meklah qaynat culus",
      "Yallih maganak culus harge numih akkaawonti",
    ],

    type: ["KULLI AYRO", "AYAM", "Kulli namma ayyaamat", "Alsi", "massos"],
  },
];
export const frequencies = [
  ["DAILY", "WEEKLY", "BI_WEEKLY", "MONTHLY", "CUSTOM"],
  ["በየቀኑ", "በየሳምንቱ", "በየሳምንቱ", "በየወሩ", "ብጁ"],
  [
    "GUYYAA GUYYAATTI",
    "TORBEE TORBEE",
    "Torban lama lamatti",
    "JI'A JI'AN",
    "AADAA",
  ],
  ["መዓልታዊ", "ሰሙናዊ", "ኣብ ነፍሲ ወከፍ ክልተ ሰሙን", "ወርሓዊ", "ብዓይነት ዝተዳለወ"],
  [
    "MAALIN WALBA",
    "TODDOBAADKII",
    "Labadii toddobaadba mar",
    "BISHII",
    "LA HABSANAY",
  ],
  ["KULLI AYRO", "AYAM", "Kulli namma ayyaamat", "Alsi", "massos"],
];

export const history = [
  "History",
  "ታሪክ",
  "Seenaa",
  "ታሪኽ",
  "Taariikhda",
  "Aydaadu",
];
export const dataList = [["start-date", "የመጀመሪያ ቀን", "guyyaa jalqabaa", ""]];
export const installmentCardLanguageOptions = [
  // ENGLISH
  {
    labels: [
      "Schedule Payment",
      "Account Number",
      "Total Amount",
      "Schedule Frequency",
      "Frequency",
      "Status",
      "Schedule Date",
      "Amount",
      "Schedule Status",
      "Reason",
    ],
    button: ["Confirm", "Decline"],
    title: ["Confirm Status Update"],
    messages: ["Current Status", "Update Status"],
    tabs: ["ALL", "Upcoming", "Transferred", "Failed"],
    toggle: ["Hide Schedules", "Show Schedules"],
    status: ["Disable", "Enable"],
    Error: ["No installments available", "No installment plans available"],
  },
  //amharic
  {
    labels: [
      "የክፍያ ጊዜ መርሐግብር",
      "የሂሳብ ቁጥር",
      "ጠቅላላ መጠን",
      "የመርሐግብር ድግግሞሽ",
      "ድግግሞሽ",
      "ሁኔታ",
      "የመርሐግብር ቀን",
      "መጠን",
      "የመርሐግብር ሁኔታ",
      "ምክንያት",
    ],
    button: ["ያረጋግጡ", "ውድቅ ያድርጉ"],
    title: ["የሁኔታ ዝመናን ያረጋግጡ"],
    messages: ["አሁን ያለ ሁኔታ", "ሁኔታ አዘምን"],
    tabs: ["ሁሉም", "የሚመጡ", "የተላለፉ", "ያልተሳኩ"],
    toggle: ["መርሐግብሮችን ደብቅ", "መርሐግብሮችን አሳይ"],
    status: ["አቁም ", "አስጀምር"],
    Error: ["የክፍያ ዕቅድ አይገኝም", "የተከፋፈለ የክፍያ ፕሮግራም አይገኝም"],
  },
  //Afan oromo
  {
    labels: [
      "Sagantaa Kaffaltii",
      "Lakkoofsa Herregaa",
      "Ida'ama Waliigalaa",
      "Sagantaa Irra Deddeebii",
      "Irra Deddeebii",
      "Haala",
      "Guyyaa Sagantaa",
      "Ida'ama",
      "Haala Sagantaa",
      "Sababa",
    ],
    button: ["Mirkaneessaa", "Kuffisi"],
    title: ["Fooyya'iinsa Haala Mirkaneessi"],
    messages: ["Haala Ammaa", "Haala Haaromsa"],
    tabs: ["Hunda", "Kan Dhufu", "Dabarfame", "Kufe"],
    toggle: ["Sagantaa Dhoksuu", "Sagantaa Agarsiisuu"],
    status: ["Dhiisii", "Dandeessisaa"],
    Error: ["Kutaa kutaan hin jiru", "Karoorri kutaa hin jiru"],
  },
  //tigre
  {
    labels: [
      "ክፍሊት መደብ",
      "ቁጽሪ ሕሳብ",
      "ጠቕላላ መጠን",
      "መደብ ድግግሞሽ",
      "ድግግም",
      "ኩነታት",
      "ዕለት መደብ",
      "መጠን",
      "ኩነታት መደብ ስራሕ",
      "ምኽንያት",
    ],
    button: ["አረጋግፁ", "ውድቅ ግበር"],
    title: ["ናይ ኩነታት ምዕባለ ምርግጋጽ"],
    messages: ["ህሉው ኩነታት", "ሁኔታ ኣዘምን"],
    tabs: ["ኩሎም", "ዝመጽእ", "ተሰጋጊሩ", "ወዲቑ"],
    toggle: ["መደባት ሕብእ", "መደባት ኣርእ"],
    status: ["ዲስከል", "ኣኽእሎ"],
    Error: ["ብኽፋል የለን", "ብኽፋል ትልሚ የለን"],
  },
  //afar
  {
    labels: [
      "Meklah Aysalu",
      "Numura Hisaab",
      "Ittat Tan Lakqo",
      "Qagaaqagi Aysalu",
      "Qagaaqago",
      "Caalata",
      "Ayro Aysalu",
      "Gide",
      "Aysalu Caalat",
      "Sabab",
    ],
    button: ["Diggoyssa", "Raddia Yakaye"],
    title: ["Caalat Asqassaabe Diggos"],
    messages: ["Awayih Caalat", "Caalat Uqusbus"],
    tabs: ["Inkih", "Yamaate", "Tatrusen", "Radeh"],
    toggle: ["Aysalu Qellis", "Aysalu Uybulluy"],
    status: ["Alif", " Xiqsis"],
    Error: ["Uli garuq mageytima", "Uli garuq ekraaro mageytimta"],
  },
  //somali
  {
    labels: [
      "Jadwalka Lacag Bixinta",
      "Lambarka Koontada",
      "Lacag Dhan",
      "Inta Jeer ee Jadwalka",
      "Soo Noqnoqda",
      "Xaaladda",
      "Taariikhda Jadwalka",
      "Qaddarka",
      "Xaaladda Jadwalka",
      "Sabab",
    ],
    button: ["Xaqiijin", "Diid"],
    title: ["Xaqiiji Cusbooneysiinta Xaaladda"],
    messages: ["Xaaladda Hadda", "Xaaladda Cusbooneysii"],
    tabs: ["Dhammaan", "Soo Socda", "Waa la Wareejiyay", "Fashilmay"],
    toggle: ["Qari Jadwalka", "Show Jadwalada"],
    status: ["Naafo", "Awood"],
    Error: ["Lama heli karo qaybo", "Qorshayaal rakibaad lama heli karo"],
  },
];
